module.exports = __webpack_public_path__ + "static/media/metropolesLogo.88fc2bba.jpg";